export default "__VITE_ASSET__Dk$hyB9T__"